import { InjectionToken } from "@angular/core";
import { Module } from "@core/modules/_types";


export const MODULES = new InjectionToken<Module>("MODULES");
